"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _TEMPLATE_EDITORS_MAP;

var MESSENGER_TEMPLATE_TYPES = {
  GENERIC: 'generic',
  TEXT: 'text'
};
var Constants = {
  ENTITY_TYPES: {
    BUTTON: "button",
    FOOTER: "footer",
    SHORT_URL: "SHORTLINK",
    IMAGE: "IMAGE",
    EMOJI: "emoji"
  },
  MESSENGER: {
    TEMPLATE_TYPES: MESSENGER_TEMPLATE_TYPES,
    TEMPLATE_EDITORS_MAP: (_TEMPLATE_EDITORS_MAP = {}, _TEMPLATE_EDITORS_MAP[MESSENGER_TEMPLATE_TYPES.GENERIC] = {
      type: 'template',
      payload: {
        "template_type": "generic",
        "elements": [{
          "title": "Title",
          "subtitle": "",
          "default_action": {
            "type": "web_url",
            "url": ""
          }
        }]
      }
    }, _TEMPLATE_EDITORS_MAP[MESSENGER_TEMPLATE_TYPES.TEXT] = {
      payload: {
        template_type: MESSENGER_TEMPLATE_TYPES.TEXT,
        text: ''
      }
    }, _TEMPLATE_EDITORS_MAP)
  }
};
var _default = Constants;
exports["default"] = _default;
module.exports = exports.default;